import { AbstractControl, ValidatorFn } from '@angular/forms';

const REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmail: ValidatorFn = (control: AbstractControl) => {
  const email: boolean = REGEX.test(control.value);

  return email ? null : { isEmail: false };
};
